import { IOpData, IReferenceType, IOpChangeState } from '../util/interfaces'
import { DataType } from '../../helpers/common-helper'
import { Utils } from '../util/utils'
import { Enums } from '../common/enums'

import { OpDataType } from '../core/op-data-type'


export class OpIssueData implements IOpData {
    
    //Properties

    public idIssueData: number
    public idIssue: number
    public idDataType: number
    public indexNbr: number
    public value: any

    //Properties end


    //NavigationProperties

    public dataType: OpDataType

    //NavigationProperties end
    

    constructor(opObj: any) {
       this.fromJSON(opObj)
    }


    //IOpChangeState implementation

    public opState: Enums.OpChangeState

    //IOpChangeState implementation end


    //IOpData implementation

    public get idData() { return this.idIssueData }
    public set idData(idData: number) { this.idIssueData = idData }
    public get indexNBR() { return this.indexNbr }
    public set indexNBR(indexNBR: number) { this.indexNbr = indexNBR }

    //IOpData implementation end

    public toString() {
        return "IssueData [" + this.idData + "]"
    }

    public fromJSON(opObj: any, compress: boolean = false) {
        if (opObj) {
            this.idIssueData = opObj.ID_ISSUE_DATA
            this.idIssue = opObj.ID_ISSUE
            this.idDataType = opObj.ID_DATA_TYPE
            this.indexNbr = opObj.INDEX_NBR
            this.value = opObj.VALUE
            this.opState = opObj.OpState

            this.dataType = opObj._DataType ? new OpDataType(opObj._DataType) : null
        } else {
            this.idIssueData = 0;
            this.opState = Enums.OpChangeState.New
        }
    }

    public toJSON(compress: boolean = false): any {
        return {
            ID_ISSUE_DATA: this.idIssueData,
            ID_ISSUE: this.idIssue,
            ID_DATA_TYPE: this.idDataType,
            INDEX_NBR: this.indexNbr,
            VALUE: this.value
        }
    }

    public static fromIOpData(data: IOpData): OpIssueData {
        const newData: OpIssueData = new OpIssueData(null)

        newData.idIssueData = data.idData,
        newData.idDataType = data.idDataType
        newData.indexNbr = data.indexNBR
        newData.value = data.value
        newData.opState = data.opState

        return newData
    }
}